/*
 * ____   ____    .__   __
 * \   \ /   /___ |  |_/  |______      ____ ___.__.
 *  \   Y   /  _ \|  |\   __  \_ \   / ___<   |  |
 *   \     (  <_> )  |_|  |  / __ \_/ /_/  >___  |
 *    \___/ \____/|____/__| (____  /\___  // ____|
 *                               \//_____/ \/
 *
 * Copyright (c) 2017-2025 Voltagy. All rights reserved.
 * https://voltagy.com
 *
 * PROPRIETARY AND CONFIDENTIAL
 *
 * This source code is the proprietary and confidential property of Voltagy.
 * Unauthorized copying, transfer, or use of this file, via any medium, is
 * strictly prohibited without the express written permission of Voltagy.
 *
 * The receipt or possession of this source code and/or related information
 * does not convey or imply any right to use it, reproduce it, disclose its
 * contents, or to manufacture, use, or sell anything that it may describe.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 *
 */

import { defineCustomElements } from "@ionic/pwa-elements/loader";
import React from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import "../assets/styles/animations.css";
import "../assets/styles/form.css";
import "../assets/styles/main.css";
import "../assets/styles/map.css";
import "../assets/styles/select.css";
import "../assets/styles/table.css";

defineCustomElements(window);

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
